import { Component, Injector, Input, OnInit } from '@angular/core';
import { BasePageComponent } from '../../../pages/base.page';

@Component({
    selector: 'app-component-random-questions-with-action-button',
    templateUrl: './randomQuestionWithActionButton.component.html',
    styleUrls: ['./randomQuestionWithActionButton.component.scss'],
})
export class RandomQuestionWithActionButtonComponent extends BasePageComponent implements OnInit {
    @Input() question: string;
    @Input() actionButton: { action: () => void; title: string };

    constructor(injector: Injector) {
        super(injector);
    }

    override ngOnInit() {
        super.ngOnInit();
    }

    onButtonClicked() {
        if (this.actionButton) {
            this.actionButton.action();
        }
    }
}
